var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIfixitHeaderLogo20Th = function SvgIfixitHeaderLogo20Th(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 183 47"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M120.316 15.311a1.882 1.882 0 0 0-1.899 1.899v13.761c0 1.061.837 1.898 1.899 1.898a1.883 1.883 0 0 0 1.898-1.898l.001-13.761a1.887 1.887 0 0 0-1.899-1.899Zm-6.684.148h-9.668a1.883 1.883 0 0 0-1.898 1.898v13.614c0 1.061.839 1.898 1.898 1.898a1.883 1.883 0 0 0 1.899-1.898V26.04h6.659c.963 0 1.726-.763 1.726-1.726s-.763-1.726-1.726-1.726h-6.659v-3.674h7.77c.962 0 1.726-.764 1.726-1.727 0-.962-.766-1.728-1.727-1.728Zm-17.782-.148a1.882 1.882 0 0 0-1.898 1.899l-.001 13.761a1.885 1.885 0 0 0 1.899 1.898 1.883 1.883 0 0 0 1.899-1.898V17.21a1.884 1.884 0 0 0-1.899-1.899Zm70.583.148h-11.099c-.963 0-1.751.79-1.751 1.751 0 .962.788 1.751 1.751 1.751h3.65v12.01c0 1.061.837 1.898 1.898 1.898a1.883 1.883 0 0 0 1.899-1.898V18.963h3.65c.962 0 1.75-.788 1.75-1.751a1.754 1.754 0 0 0-1.748-1.753Zm-17.684-.148a1.883 1.883 0 0 0-1.899 1.899v13.761c0 1.061.838 1.898 1.899 1.898a1.884 1.884 0 0 0 1.899-1.898V17.21a1.884 1.884 0 0 0-1.899-1.899Zm-6.072.737a1.932 1.932 0 0 0-2.736 0l-5.41 5.409-5.409-5.409a1.932 1.932 0 0 0-2.736 0 1.932 1.932 0 0 0 0 2.736l5.409 5.409-5.409 5.41a1.932 1.932 0 0 0 1.368 3.302 1.93 1.93 0 0 0 1.368-.566l5.409-5.41 5.409 5.41a1.93 1.93 0 0 0 1.368.566 1.932 1.932 0 0 0 1.368-3.302l-5.409-5.41 5.409-5.409c.758-.755.758-1.98.001-2.736Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.057 34.066c14.878-10.76 17.659-13.129 17.659-16.526 0-2.368-2.214-3.604-4.891-3.604-3.656 0-6.539 1.442-9.01 3.758l-4.891-5.869c3.655-4.016 9.113-5.715 13.901-5.715 8.083 0 13.9 4.531 13.9 11.43 0 5.251-3.758 9.73-12.974 15.702h13.231v7.722H18.057v-6.898Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ifixit-header-logo-20th_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.348 5.782c-9.973 0-18.056 8.083-18.056 18.053 0 9.973 8.083 18.055 18.056 18.055 9.97 0 18.055-8.085 18.055-18.055-.002-9.97-8.085-18.053-18.055-18.053Zm5.031 18.814 3.569 4.713c.295.392.313 1.041.038 1.447l-.182.264a5.92 5.92 0 0 1-1.227 1.252l-.43.302c-.398.282-1.045.273-1.435-.025l-4.713-3.573c-.389-.296-1.028-.296-1.419 0l-4.713 3.573c-.39.296-1.042.312-1.442.034l-.312-.215a5.916 5.916 0 0 1-1.242-1.236l-.269-.385c-.28-.401-.269-1.048.027-1.44l3.574-4.715c.295-.392.295-1.03 0-1.42l-3.576-4.715c-.296-.392-.307-1.037-.025-1.437l.305-.43a5.836 5.836 0 0 1 1.249-1.227l.267-.182c.405-.275 1.054-.257 1.444.038l4.713 3.574c.389.295 1.028.295 1.419 0l4.713-3.574c.39-.295 1.053-.333 1.476-.085l.493.291c.423.249.96.804 1.2 1.232l.174.313c.238.428.191 1.098-.107 1.489l-3.569 4.716c-.298.391-.298 1.032 0 1.421Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ifixit-header-logo-20th_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.348 5.782c-9.973 0-18.056 8.083-18.056 18.053 0 9.973 8.083 18.055 18.056 18.055 9.97 0 18.055-8.085 18.055-18.055-.002-9.97-8.085-18.053-18.055-18.053Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m40.409 0-1.813 1.767c1.697 1.742 3.861 3.185 4.574 2.49l1.812-1.767c-.712.695-2.884-.758-4.573-2.49Z",
    style: {
      fill: "#b0d100",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.339 40.267-1.578-1.129c-1.085 1.515-1.881 3.343-1.26 3.786l1.578 1.129c-.621-.443.181-2.278 1.26-3.786Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.139 10.087 2.089 1.274c1.224-2.007 2.056-4.38 1.234-4.88l-2.089-1.274c.821.5-.017 2.883-1.235 4.88Z",
    style: {
      fill: "#b0d100",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.938 5.27-2.22.829c.795 2.132 2.103 4.185 2.976 3.859l2.22-.829c-.873.326-2.185-1.738-2.976-3.859Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.012 38.218-3.054 1.141c1.095 2.934 2.894 5.757 4.094 5.309l3.054-1.14c-1.2.448-3.005-2.391-4.094-5.31Z",
    style: {
      fill: "#b0d100",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.045.507-2.367.217c.207 2.274.932 4.604 1.862 4.52l2.368-.218c-.93.086-1.656-2.257-1.863-4.519ZM18.902 3.292l-.67-1.865c-1.792.644-3.522 1.716-3.259 2.449l.671 1.866c-.263-.733 1.476-1.809 3.258-2.45Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.955 1.492 1.069 1.768c-1.699 1.027-3.703 1.72-4.123 1.026l-1.068-1.768c.42.696 2.432-.005 4.122-1.026ZM128.651 40.388l-.688-1.144c1.099-.661 2.396-1.107 2.667-.658l.687 1.145c-.27-.45-1.573 0-2.666.657ZM156.844 40.282l.91-.864c.829.874 1.502 1.973 1.144 2.312l-.91.863c.358-.339-.319-1.442-1.144-2.311Z",
    style: {
      fill: "#ff2a51",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.935 8.927 1.801.771c-.74 1.731-1.899 3.375-2.607 3.072L.328 12c.707.303 1.871-1.352 2.607-3.073ZM79.978 43.27l1.342.575c-.552 1.289-1.415 2.514-1.942 2.289l-1.342-.575c.527.226 1.394-1.006 1.942-2.289Z",
    style: {
      fill: "#b0d100",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.591 26.017-1.998-2.071c1.99-1.92 4.499-3.482 5.284-2.668l1.997 2.072c-.784-.815-3.304.759-5.283 2.667Z",
    style: {
      fill: "#ffb300",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.839 30.153 1.225 1.575C3.551 32.905 1.707 33.8 1.226 33.18L0 31.606c.482.619 2.334-.282 3.839-1.453Z",
    style: {
      fill: "#ff2a51",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.829 43.155.423 1.659c-1.592.407-3.349.478-3.516-.174l-.424-1.658c.166.651 1.931.578 3.517.173Z",
    style: {
      fill: "#b0d100",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.712 10.302-1.76-.501c.481-1.69 1.36-3.35 2.052-3.154l1.76.5c-.691-.197-1.574 1.473-2.052 3.155ZM105.678 4.44l1.538-.856c.821 1.477 1.351 3.205.747 3.54l-1.537.856c.604-.337.07-2.072-.748-3.54Z",
    style: {
      fill: "#ff2a51",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.267 4.571.919 1.477c-1.419.883-3.099 1.49-3.461.911l-.919-1.478c.361.581 2.049-.032 3.461-.91Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.596 46.108-.527 1.68c-1.614-.507-3.188-1.395-2.982-2.055l.527-1.68c-.207.661 1.376 1.551 2.982 2.055Z",
    style: {
      fill: "#ff2a51",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.341 28.067.541 1.935c-1.859.52-3.92.649-4.133-.11l-.541-1.937c.212.76 2.284.628 4.132.112Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.167 7.953.594 2.002c-1.922.57-4.059.738-4.292-.048l-.594-2.002c.234.787 2.38.615 4.292.048Z",
    style: {
      fill: "#ffb300",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.428 19.693-.651-1.843c1.771-.625 3.761-.884 4.016-.16l.651 1.842c-.256-.723-2.255-.461-4.016.161Z",
    style: {
      fill: "#b0d100",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.557 44.422-.018-2.547c2.448-.018 5.01.51 5.017 1.511l.017 2.548c-.007-1.001-2.582-1.528-5.016-1.512Z",
    style: {
      fill: "#ff2a51",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.714 41.819-.105-2.171c2.085-.101 4.287.258 4.329 1.111l.105 2.171c-.042-.853-2.255-1.212-4.329-1.111ZM173.346 31.768l-1.442-.192c.185-1.386.686-2.793 1.254-2.717l1.441.192c-.566-.075-1.069 1.339-1.253 2.717Z",
    style: {
      fill: "#ffb300",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.159 5.593-1.574 1.974c-1.895-1.513-3.539-3.515-2.92-4.29l1.572-1.973c-.617.775 1.037 2.786 2.922 4.289Z",
    style: {
      fill: "#ff2a51",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.952 42.627.34 2.573c2.472-.326 4.984-1.218 4.85-2.23l-.34-2.574c.133 1.011-2.392 1.906-4.85 2.231Z",
    style: {
      fill: "#0071ce",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.462 37.629-2.147-.166c-.159 2.062.134 4.254.978 4.319l2.147.165c-.843-.065-1.136-2.267-.978-4.319Z",
    style: {
      fill: "#ffb300",
      fillRule: "nonzero"
    }
  }));
};
export default SvgIfixitHeaderLogo20Th;